<template>
	<div>
		<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
		<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
		<div class="whiteBG p-3 education-Section mb-4">
			<section class="blockElement mainBanner">
				<div class="inner-banner-custom row align-items-center">
					<div class="col-12 text-center">
						<h2 class="mb-3">
							{{ $t("video_video") }} <span>{{ $t("video_tut") }}</span>
						</h2>
						<p>{{ $t("video_intrestedforex") }}</p>
					</div>
				</div>
			</section>

      <section
        class="blockElement doticonHover tp position-relative videroTab-tutorial between-footer"
        id="video_list"
      >
        <div class="row m-0">
          <div class="col-12" v-if="Object.keys(course_cat).length > 0">
            <div class="inMobileTab">
              <select
                class="form-control d-block d-lg-none"
                v-model="courseId"
                @change="mobchangeTab()"
              >
                <option :value="list._id" v-for="list in course_cat.course">
                  {{ list.course }}
                </option>
              </select>
              <!-- {{ course_cat.course }} -->
              <!-- <ul
                class="hideMob nav nav-tabs tabBachkrod leftCustom-width mb-5 lowerCase"
                v-if="course_cat.course.length > 0"
              > 
                <li class="nav-item" v-for="list in course_cat.course">
                  <a
                    class="nav-link"
                    href="#"
                    v-on:click.prevent="courseTabFunc(list._id, '')"
                    :class="courseId == list._id ? 'active' : ''"
                    >{{ list.course }}</a
                  >
                </li>
              </ul> -->
              <ul
                class="hideMob nav nav-tabs tabBachkrod leftCustom-width mb-5 lowerCase"
                v-if="filteredCourses.length > 0"
              > 
                <li class="nav-item" v-for="list in filteredCourses" :key="list._id">
                  <a
                    class="nav-link"
                    href="#"
                    v-on:click.prevent="courseTabFunc(list._id, '')"
                    :class="courseId == list._id ? 'active' : ''"
                    >{{ list.course }}</a
                  >
                </li>
              </ul>

							<ul class="nav nav-tabs tabBachkrod leftCustom-width in-trading mb-md-5 mb-4 lowerCase videoCatogary-list border-0 justify-content-center"
								v-if="Object.keys(course_cat.category).length > 0 &&
			course_cat.category[courseId].length > 0
			">
								<li class="nav-item" v-for="list in course_cat.category[courseId]">
									<a class="nav-link" href="#" v-on:click.prevent="catTabFunc(list._id)"
										:class="categoryId == list._id ? 'active' : ''">{{ list.category }}
									</a>
								</li>
							</ul>
						</div>

						<div class="tab-responsive customTab-show active" v-if="Object.keys(course_cat.category).length > 0 &&
			course_cat.category[courseId].length > 0
			">
							<div class="row m-0">
								<div class="col-12 col-lg-4 col-md-6 repeateVid" v-for="(list, index) in videoTutorial"
									v-if="videoTutorial.length > 0">
									<div class="cardWrap vid position-relative">
										<video class="video-js" :id="'video' + index" width="100%" height="238"
											:src="list.videoUrl" controls v-show="videoIndex == index"></video>
										<div class="mainContent-vid" v-if="videoIndex != index">
											<div class="logoVideo">
												<img width="135px" src="../../../../static/fxView/images/white-logo.svg" alt="" />
											</div>
											<a href="#" class="playInc" v-on:click.prevent="videoPlayPause(index)">
												<feather type="play-circle"></feather>
											</a>
											<p class="inntBotm">{{ list.title }}</p>
										</div>
									</div>
								</div>
								<!-- <div class="col-12 col-md-4" v-for="list,index in videoTutorial" v-if="videoTutorial.length > 0">
                                    <div class="cardWrap vid position-relative">
                                        <video width="100%" height="235" :src="list.videoUrl"  controls :autoplay="true" v-if="videoIndex == index"></video>
                                        <div class="videoImage" v-else>
                                            <img height="235" src="../../../../static/fxview/images/video/demoImage-1.jpg" alt="Image">
                                            <a href="#" class="playInc" v-on:click.prevent="videoIndex = index"><feather type="youtube"></feather> </a>
                                        </div>
                                        <p class="inntBotm">{{list.title}}</p>
                                    </div>
                                </div> -->
								<div class="col-12" v-if="videoTutorial.length == 0">
									<div class="col-12 tab-pane whiteBG p-3 h-100 text-center" id="ca">
										<h3>No video available</h3>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12" v-if="Object.keys(course_cat).length == 0 ||
			(course_cat.course && course_cat.course.length == 0) ||
			(course_cat.category &&
				(Object.keys(course_cat.category).length == 0 ||
					course_cat.category[courseId].length == 0))
			">
						<div class="tab-pane whiteBG p-3 h-100 text-center" id="ca" v-if="!pageLoader">
							<h3>No video available</h3>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>
<script>
import { Const } from "@/plugins/fxView/provider/candle-history/lib/const.cls";
import { fxViewMixins } from "@/plugins/fxView";
export default {
  name: "Video-Tutorials",
  mixins: [fxViewMixins],
  data() {
    return {
      showData: "zero",
      pageLoader: false,
      msg_type: "",
      response_msg: "",
      videoIndex: -1,
      course_cat: {},
      courseId: "",
      categoryId: "",
      course_cat: {
        course: []
      },
      courseId: null
    };
  },
  computed: {
    filteredCourses() {
      return this.course_cat.course.filter(
        (list) =>
          list.course !== "MT5 Tutorials" && list.course !== "MT5 Mobile Tutorials"
      );
    }
  },
  methods: {
    courseTabFunc(id, someValue) {
      this.courseId = id;
    },
    watchNow() {
      try {
        this.videoPlayPause(0);
        setTimeout(function () {
          var elmnt = document.getElementById("video_list");
          elmnt.scrollIntoView();
          document.getElementById(id).focus();
          var top = $(window).scrollTop();
          $(window).scrollTop(top - 380);
        }, 100);
      } catch (e) {}
    },
    videoPlayPause(getIndex) {
      try {
        this.videoIndex = getIndex;
        var videos = document.querySelectorAll("video");
        // console.log(videos.length)
        for (var i = 0; i <= videos.length - 1; i++) {
          var allVideoId = videos[i].id;
          var myVideo = videos[i];
          var clickVideoId = "video" + getIndex;
          if (allVideoId == clickVideoId) {
            if (myVideo.paused) {
              myVideo.play();
            } else {
              myVideo.pause();
            }
          } else {
            myVideo.pause();
          }
        }
      } catch (e) {}
    },
    mobchangeTab() {
      this.courseTabFunc(this.courseId, "changed");
    },
    courseTabFunc(courseId, from) {
      // console.log('-------------',courseId)
      if (this.courseId != courseId || from) {
        this.$store.commit(Const.SET_VIDEO_TUTORIAL, []);
        this.courseId = courseId;
        if (this.course_cat.category[courseId].length > 0) {
          this.categoryId = this.course_cat.category[courseId][0]._id;
          this.videoIndex = -1;
          this.listing();
        }
      }
    },
    catTabFunc(categoryId) {
      this.categoryId = categoryId;
      this.listing();
    },
    listing() {
      let input_json = {
        globalParams: {
          course_id: this.courseId,
          cat_id: this.categoryId,
        },
        localParams: { parameter: this },
      };
      this._runGetVideoTutorial(input_json);
    },
  },
  created() {
    let input_json = {
      globalParams: {},
      localParams: { parameter: this },
    };
    this._runGetTutCourseCategory(input_json);
    this.videoPlayPause("-1");
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/tradingtools/video_tutorials.vue